import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Button, Dialog, VideoCameraIcon } from "@/shared/ui";

export const UpcomingConsultationModal = ({ show, onClose }: ModalProps) => (
  <Dialog.Root open={show} onOpenChange={onClose}>
    <Dialog.Content>
      <Dialog.Header icon={VideoCameraIcon}>
        <Dialog.Title>{t`Video-consultation Needed`}</Dialog.Title>
        <Dialog.Description>
          {t`Hi there! Based on your responses, we can't process your refill request right now. You'll need to have a video consultation with a provider.`}
          <br />
          {t`But good news! You already have a video consultation scheduled for this week. You can discuss your situation during that appointment.`}
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.Footer>
        <Button asChild size="lg">
          <Link to={ROUTES.CONSULTATIONS.OVERVIEW}>
            {t`Review consultations`}
          </Link>
        </Button>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>
);
